import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Document = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="document icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.82843C3 6.29799 3.21071 5.78929 3.58579 5.41421L8.41421 0.585787C8.78929 0.210714 9.29799 0 9.82843 0L19 0C20.1046 0 21 0.895431 21 2V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V6.82843ZM10 7V2.5L5.5 7H10ZM7 10.25C6.44772 10.25 6 10.6977 6 11.25C6 11.8023 6.44772 12.25 7 12.25H17C17.5523 12.25 18 11.8023 18 11.25C18 10.6977 17.5523 10.25 17 10.25H7ZM6 15.5C6 14.9477 6.44772 14.5 7 14.5H13C13.5523 14.5 14 14.9477 14 15.5C14 16.0523 13.5523 16.5 13 16.5H7C6.44772 16.5 6 16.0523 6 15.5ZM7 18.75C6.44772 18.75 6 19.1977 6 19.75C6 20.3023 6.44772 20.75 7 20.75H9C9.55228 20.75 10 20.3023 10 19.75C10 19.1977 9.55228 18.75 9 18.75H7Z"
    />
  </svg>
)
